export const passwordText = 'Contraseña' // NOSONAR
export const headerText = 'contraseña' // NOSONAR
export const sendText = 'Enviar'
export const requestPass = 'Solicitar contraseña'
export const termsAndConditionsText = 'Términos y condiciones'
export const simulatorText = 'Simulador'
export const generalFundAdministrationText = 'Administración del fondo general'
export const consultRepresentativeDetailsText = 'Consulta de detalles representantes'
export const availableDestinationsText = 'Destinos disponibles'
export const selectedDestinationsText = 'Destinos seleccionados'
export const loginText = 'Iniciar sesión'
export const getIntoText = 'Ingresar'
export const dataPrivacyPolicyText = 'Política de privacidad de datos'
export const metaText = 'Meta'
export const cancelText = 'Cancelar'
export const acceptText = 'Aceptar'
export const backText = 'Regresar'
export const downloadDocumentText = 'Descargar documento'
export const closeText = 'Cerrar'
export const DELEGATE = 'DELEGATE'
export const continueText = 'Continuar'
export const placeholderPasswordText =
  'Mínimo 8 caracteres alfanuméricos, al menos 1 mayúscula y 1 caracter especial'
export const destinationText = 'Destino'
export const showMoreText = 'Ver más'

export const sinceText = 'Desde:'
export const stayText = 'Estadía:'
export const includePriceByPersonText = 'Precio por persona incluye:'
export const daysText = 'días y'
export const nightsText = 'noches'
export const peopleText = 'personas'
export const maxCapacityText = 'Capacidad máxima:'
export const notIncludeTitleText = 'NO INCLUYE (Valores incluido IVA)'
export const conditionsAndObservationsTitleText = 'CONDICIONES DE PAGO / OBSERVACIONES'
